// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import OffRoundSvg from '@rsuite/icon-font/lib/action/OffRound';
var OffRound = createSvgIcon({
  as: OffRoundSvg,
  ariaLabel: 'off round',
  category: 'action',
  displayName: 'OffRound'
});
export default OffRound;